/** Skip to main content link — keyboard-only, hidden until focused. */

export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-[100] focus:rounded focus:bg-amber focus:px-4 focus:py-2 focus:font-mono focus:text-sm focus:font-medium focus:text-ink"
    >
      Skip to main content
    </a>
  )
}
